class MPureHeader extends HTMLElement {
  constructor() {
    super();
    this.selectors = {
      headers: ["header"],
      logos: [".m-logo"],
      topbar: ".m-topbar",
      headerWrapper: ".m-header__wrapper",
      topbarClose: ".m-topbar__close",
    };
    this.classes = {
      scrollUp: "scroll-up",
      scrollDown: "scroll-down",
      stuck: "stuck",
      always: "header-sticky-always",
      headerScrollUp: "header-scroll-up",
      headerScrollDown: "header-scroll-down",
    };
    this.lastScrollY = window.scrollY || 0;
    this.scrollTicking = false;
  }

  connectedCallback() {
    // Wait for queryDomNodes to be available
    if (typeof queryDomNodes === 'undefined') {
      setTimeout(() => this.connectedCallback(), 100);
      return;
    }
    
    this.domNodes = queryDomNodes(this.selectors, this);
    
    if (!this.domNodes || !this.domNodes.headerWrapper) {
      return;
    }
    
    this.innerWidth = window.innerWidth;
    this.headerOffsetTop = this.domNodes.headerWrapper.offsetTop;
    this.headerHeight = this.domNodes.headerWrapper.offsetHeight;
    this.stickyHeader = this.dataset.sticky;
    
    // Create spacer element to prevent content jump when header becomes fixed
    this.createSpacer();
    
    this.init();
  }

  init() {
    this.transparentHeader =
      this.domNodes &&
      this.domNodes.headers[0] &&
      "true" === this.domNodes.headers[0].dataset.transparent;
    this.initAddon();
    this.handleSticky();
    
    document.addEventListener("matchMobile", () => {
      this.updateHeaderDimensions();
      this.handleSticky();
    });
    
    document.addEventListener("unmatchMobile", () => {
      this.updateHeaderDimensions();
      this.handleSticky();
    });
    
    document.addEventListener("matchTablet", () => {
      this.updateHeaderDimensions();
      this.handleSticky();
    });
    
    document.addEventListener("unmatchTablet", () => {
      this.updateHeaderDimensions();
      this.handleSticky();
    });
    
    if (typeof SiteNav !== 'undefined') {
      this.siteNav = new SiteNav(this);
    }
    window.__sfPureHeader = this;
    
    this.resizeTimeout = null;
    this.resizeRAF = null;
    window.addEventListener("resize", () => {
      this.innerWidth = window.innerWidth;
      // Clear existing timeout and animation frame
      if (this.resizeTimeout) {
        clearTimeout(this.resizeTimeout);
        this.resizeTimeout = null;
      }
      if (this.resizeRAF) {
        cancelAnimationFrame(this.resizeRAF);
        this.resizeRAF = null;
      }
      // Use requestAnimationFrame to wait for layout, then debounce
      this.resizeRAF = requestAnimationFrame(() => {
        this.resizeTimeout = setTimeout(() => {
          this.updateHeaderDimensions();
          this.handleSticky();
          this.resizeTimeout = null;
          this.resizeRAF = null;
        }, 100);
      });
    });
  }

  createSpacer() {
    // Create a spacer element that maintains the header's space when it becomes fixed
    this.spacer = document.createElement('div');
    this.spacer.className = 'm-header__spacer';
    this.spacer.style.display = 'none';
    this.spacer.style.width = '100%';
    this.spacer.style.height = this.headerHeight + 'px';
    this.spacer.style.visibility = 'hidden';
    this.spacer.style.pointerEvents = 'none';
    
    // Insert spacer right after the header wrapper
    if (this.domNodes.headerWrapper && this.domNodes.headerWrapper.parentNode) {
      this.domNodes.headerWrapper.parentNode.insertBefore(
        this.spacer,
        this.domNodes.headerWrapper.nextSibling
      );
    }
  }

  updateSpacer() {
    if (this.spacer && this.domNodes && this.domNodes.headerWrapper) {
      // Update spacer height to match current header height
      this.spacer.style.height = this.headerHeight + 'px';
    }
  }

  showSpacer() {
    if (this.spacer) {
      this.spacer.style.display = 'block';
    }
  }

  hideSpacer() {
    if (this.spacer) {
      this.spacer.style.display = 'none';
    }
  }

  updateHeaderDimensions() {
    // Re-query DOM nodes in case they've changed
    if (this.selectors) {
      this.domNodes = queryDomNodes(this.selectors, this);
    }
    if (this.domNodes && this.domNodes.headerWrapper) {
      // Force a reflow to ensure accurate measurements
      void this.domNodes.headerWrapper.offsetHeight;
      this.headerOffsetTop = this.domNodes.headerWrapper.offsetTop;
      this.headerHeight = this.domNodes.headerWrapper.offsetHeight;
      // Update spacer height when header dimensions change
      this.updateSpacer();
    }
  }

  initAddon() {
    if (typeof Megamenu !== 'undefined') {
      this.megamenu = new Megamenu(this);
    }
    if (typeof Shopify !== 'undefined' && Shopify.designMode) {
      MinimogTheme = MinimogTheme || {};
      if (MinimogTheme && MinimogTheme.Wishlist) {
        MinimogTheme.Wishlist.updateWishlistCount();
      }
    }
  }

  handleSticky() {
    // Remove existing scroll listener if it exists
    if (this.scrollHandler) {
      window.removeEventListener("scroll", this.scrollHandler);
    }
    
    // Force a reflow to ensure accurate measurements
    void document.body.offsetHeight;
    let s = 20;
    const headerGroups = document.querySelectorAll(".shopify-section-group-header-group");
    headerGroups.forEach((e) => {
      // Force reflow on each element to ensure accurate height
      void e.offsetHeight;
      if (!e.classList.contains("m-section-header") && 
          !e.classList.contains("m-section-scaling-logo")) {
        s += e.offsetHeight;
      }
    });
    
    const topbar = document.querySelector(".m-topbar");
    if (topbar) {
      void topbar.offsetHeight;
      s += topbar.offsetHeight;
    }
    
    // Ensure instance variables are initialized
    if (this.lastScrollY === undefined || this.lastScrollY === null) {
      this.lastScrollY = window.scrollY || 0;
    }
    if (this.scrollTicking === undefined || this.scrollTicking === null) {
      this.scrollTicking = false;
    }
    
    this.scrollHandler = () => {
      if (!this.scrollTicking) {
        window.requestAnimationFrame(() => {
          // Recalculate header height in case it changed
          if (this.domNodes && this.domNodes.headerWrapper) {
            this.headerHeight = this.domNodes.headerWrapper.offsetHeight;
          }
          
          // Calculate the threshold: header should only become fixed when completely out of view
          const stickyThreshold = s + this.headerHeight;
          
          const currentScrollY = window.scrollY;
          
          // If we're at the top or header is still visible, remove all sticky classes
          if (currentScrollY <= stickyThreshold) {
            this.classList.remove(
              this.classes.scrollUp,
              this.classes.scrollDown,
              this.classes.stuck,
              this.classes.always
            );
            document.body.classList.remove(
              this.classes.headerScrollUp,
              this.classes.headerScrollDown
            );
            // Hide spacer when header is in normal flow
            this.hideSpacer();
            this.lastScrollY = currentScrollY;
            this.scrollTicking = false;
            return;
          }
          
          // Handle on_scroll_up mode - only activate when header is completely out of view
          if ("on_scroll_up" === this.stickyHeader) {
            const wasStuck = this.classList.contains(this.classes.stuck);
            const isFirstStuck = !wasStuck;
            
            // Determine scroll direction
            // Use smaller threshold for scroll-up (more sensitive) to show header sooner
            // Use larger threshold for scroll-down to prevent jitter
            const scrollDelta = currentScrollY - this.lastScrollY;
            const scrollUpThreshold = -1; // Very sensitive - show header with just 1px scroll up
            const scrollDownThreshold = 5; // Less sensitive - prevent jitter when scrolling down
            
            // When first becoming stuck, immediately add scroll-down to start hidden
            // This prevents any visible flash before the class is applied
            if (isFirstStuck) {
              // CRITICAL: Apply transform BEFORE adding stuck class to prevent flash
              // Set inline style first to hide it immediately
              if (this.domNodes && this.domNodes.headerWrapper) {
                // Apply transform and disable transition BEFORE making it fixed
                this.domNodes.headerWrapper.style.transform = 'translate3d(0, -100%, 0)';
                this.domNodes.headerWrapper.style.transition = 'none';
                // Force a reflow to ensure transform is applied
                void this.domNodes.headerWrapper.offsetHeight;
              }
              
              // Now add classes - header is already hidden via inline style
              this.classList.add(this.classes.stuck, this.classes.scrollDown);
              document.body.classList.add(this.classes.headerScrollDown);
              
              // Show spacer when header becomes fixed to prevent content jump
              this.showSpacer();
              
              // Only show header if we're actively scrolling up
              if (scrollDelta < scrollUpThreshold) {
                // Scrolling up - show header (enable transition on next frame)
                requestAnimationFrame(() => {
                  // Remove inline styles to let CSS take over
                  if (this.domNodes && this.domNodes.headerWrapper) {
                    this.domNodes.headerWrapper.style.transform = '';
                    this.domNodes.headerWrapper.style.transition = '';
                  }
                  this.classList.remove(this.classes.scrollDown);
                  document.body.classList.remove(this.classes.headerScrollDown);
                  this.classList.add(this.classes.scrollUp);
                  document.body.classList.add(this.classes.headerScrollUp);
                });
              } else {
                // Already hidden, remove inline styles on next frame to let CSS handle it
                requestAnimationFrame(() => {
                  if (this.domNodes && this.domNodes.headerWrapper) {
                    this.domNodes.headerWrapper.style.transform = '';
                    this.domNodes.headerWrapper.style.transition = '';
                  }
                });
              }
            } else {
              // Already stuck, just update the stuck class if needed
              this.classList.add(this.classes.stuck);
              // Show spacer when header becomes fixed to prevent content jump
              this.showSpacer();
              
              // Determine direction based on scroll
              if (scrollDelta > scrollDownThreshold) {
                // Scrolling down - hide header
                this.classList.remove(this.classes.scrollUp);
                document.body.classList.remove(this.classes.headerScrollUp);
                this.classList.add(this.classes.scrollDown);
                document.body.classList.add(this.classes.headerScrollDown);
              } else if (scrollDelta < scrollUpThreshold) {
                // Scrolling up - show header (very sensitive threshold)
                this.classList.remove(this.classes.scrollDown);
                document.body.classList.remove(this.classes.headerScrollDown);
                this.classList.add(this.classes.scrollUp);
                document.body.classList.add(this.classes.headerScrollUp);
              }
            }
          } else if ("always" === this.stickyHeader) {
            this.classList.add(this.classes.always);
          }
          
          this.lastScrollY = currentScrollY;
          this.scrollTicking = false;
        });
        this.scrollTicking = true;
      }
    };
    
    // Initialize scroll position
    this.scrollHandler();
    
    window.addEventListener("scroll", this.scrollHandler, { passive: true });
  }
}

customElements.define("m-pure-header", MPureHeader);

